import { Selector } from '@ngxs/store';
import { CustomerEquipmentUpgradeAgreement } from '../../models/equipment-upgrade-agreement.model';
import { HardwareOfferingWithMobilbytteDTO } from '../../models/mobilephone-variant';
import { MobilBytteState, MobilBytteStateModel } from './mobilbytte.state';
import { isMobilBytteAgreementEligibleForBytteBytte } from '@app/core/utils';

export class MobilBytteSelectors {
  @Selector([MobilBytteState])
  public static isLoadingSendEquipmentUpgradeSms(state: MobilBytteStateModel): boolean {
    return state.isLoadingSendEquipmentUpgradeSms;
  }

  @Selector([MobilBytteState])
  public static existingEquipmentUpgradeAgreements(state: MobilBytteStateModel): CustomerEquipmentUpgradeAgreement[] {
    return state.existingEquipmentUpgradeAgreements;
  }

  @Selector([MobilBytteState])
  public static isLoadingEquipmentUpgradeAgreements(state: MobilBytteStateModel): boolean {
    return state.isLoadingEquipmentUpgradeAgreements;
  }

  @Selector([MobilBytteState])
  public static isLoadingMobilBytteBytteRegistration(state: MobilBytteStateModel): boolean {
    return state.isLoadingMobilBytteBytteRegistration;
  }

  @Selector([MobilBytteState])
  public static isRefreshingEquipments(state: MobilBytteStateModel): boolean {
    return state.isRefreshingEquipments;
  }

  @Selector([MobilBytteState])
  public static hasRefreshedEquipments(state: MobilBytteStateModel): boolean {
    return state.hasRefreshedEquipments;
  }

  @Selector([MobilBytteState])
  public static mobilBytteOfferingSelected(state: MobilBytteStateModel): HardwareOfferingWithMobilbytteDTO {
    return state.mobilBytteOfferingSelected;
  }

  @Selector([MobilBytteState])
  public static hasMobilBytteBytteInCart(state: MobilBytteStateModel): boolean {
    return state.existingEquipmentUpgradeAgreements.some(x => !!x.redemptionId);
  }

  @Selector([MobilBytteState])
  public static mobilBytteAgreementsAvailableForBytteBytte(
    state: MobilBytteStateModel
  ): CustomerEquipmentUpgradeAgreement[] {
    return state.existingEquipmentUpgradeAgreements?.filter(agreement =>
      isMobilBytteAgreementEligibleForBytteBytte(agreement)
    );
  }
}
